import { FSXAProxyApi } from 'fsxa-api'

export const remoteProxyApiPath = '/api/remote/fsxa'

const baseUrl = () : string => `${process.client ? window.location.origin : 'http://localhost:3000'}${remoteProxyApiPath}`
export default new FSXAProxyApi(baseUrl())
